import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { catchError, of } from 'rxjs';
import { Theme } from '@modules/settings/types/theme';
import { ThemeService } from '@modules/settings/services/theme.service';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.less',
    standalone: false
})
export class AuthComponent {

  // Public
  public email?: string;
  public password?: string;
  public showPassword = false;
  public error?: string;
  public theme?: Theme;

  /**
   * Constructor
   */

  constructor(
    private authService: AuthService,
    private themeService: ThemeService
  ) {
    // Theme
    this.theme = this.themeService.theme;
  }

  /**
   * Methods
   */

  login(): void {
    if (this.email?.length && this.password?.length) {
      this.authService.login(this.email, this.password)
        .pipe(
          catchError(error => {
            if (error) {
              this.error = ((error.error.message instanceof Array) ? error.error.message.join('\n') : error.error.message);
            }
            return of();
          })
        )
      .subscribe(() => {});
    }
  }

}
